const warning = 'Each signature is for a specific purpose. If you do not know how to use signatures then it is best ' +
  'to leave this option alone.';
export const strings = {
  signatureWarning: `
  A signature should only be assigned when the system needs to access the value of this field for built in business rules. ${warning}`,
  fieldGroupSignatureWarning: `
  A signature should only be assigned when the system needs to access the field group for built in business rules. ${warning}`
};




// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/strings.ts